/* Poison Ivy Plant Lady — Theme JS */

// ── CUSTOM CURSOR ──
(function() {
  const dot = document.getElementById('cursorDot');
  const ring = document.getElementById('cursorRing');
  if (!dot || !ring) return;
  let mx = 0, my = 0, rx = 0, ry = 0;
  document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
  function tick() {
    if (dot) { dot.style.left = mx + 'px'; dot.style.top = my + 'px'; }
    rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12;
    if (ring) { ring.style.left = rx + 'px'; ring.style.top = ry + 'px'; }
    requestAnimationFrame(tick);
  }
  tick();
  document.addEventListener('mouseleave', () => { if(dot) dot.style.opacity='0'; if(ring) ring.style.opacity='0'; });
  document.addEventListener('mouseenter', () => { if(dot) dot.style.opacity='1'; if(ring) ring.style.opacity='0.6'; });
})();

// ── STICKY NAV ──
(function() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
})();

// ── SCROLL REVEAL ──
(function() {
  const els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  if (!els.length) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1 });
  els.forEach(el => obs.observe(el));
})();

// ── MOBILE MENU ──
function toggleMobileMenu() {
  const nav = document.getElementById('mobileNav');
  const btn = document.getElementById('mobileMenuBtn');
  const overlay = document.getElementById('site-overlay');
  if (!nav) return;
  const open = nav.classList.toggle('open');
  if (btn) btn.setAttribute('aria-expanded', open);
  if (overlay) overlay.classList.toggle('active', open);
  document.body.style.overflow = open ? 'hidden' : '';
}

// ── CART DRAWER ──
function openCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('site-overlay');
  if (drawer) drawer.classList.add('open');
  if (overlay) overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
  refreshCart();
}
function closeCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('site-overlay');
  if (drawer) drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('active');
  document.body.style.overflow = '';
}
document.getElementById('site-overlay')?.addEventListener('click', () => {
  closeCartDrawer();
  const nav = document.getElementById('mobileNav');
  if (nav && nav.classList.contains('open')) toggleMobileMenu();
});

// ── REFRESH CART ──
function refreshCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
    })
    .catch(console.error);
}

function updateCartCount(count) {
  const el = document.querySelector('.cart-count');
  if (!el) return;
  el.textContent = count;
  el.classList.toggle('visible', count > 0);
}

function money(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function renderCartDrawer(cart) {
  const body = document.getElementById('cartDrawerItems');
  const footer = document.getElementById('cartDrawerFooter');
  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn-outline" onclick="closeCartDrawer()" style="margin-top:1rem;">Shop plants</a></div>';
    if (footer) footer.style.display = 'none';
    return;
  }
  if (footer) footer.style.display = 'block';

  body.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-line-key="${item.key}">
      <div class="cart-item-img">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : '<div style="background:var(--card);width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:2rem;">🌿</div>'}
      </div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
        <div class="cart-item-bottom">
          <div class="qty-input">
            <button class="qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
          <span class="cart-item-price">${money(item.final_line_price)}</span>
        </div>
        <button class="cart-item-remove" onclick="updateCartItem('${item.key}', 0)">Remove</button>
      </div>
    </div>
  `).join('');

  const subtotalEl = document.getElementById('cartSubtotal');
  if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
}

function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then(r => r.json())
    .then(cart => { updateCartCount(cart.item_count); renderCartDrawer(cart); })
    .catch(console.error);
}

// ── ADD TO CART ──
function addToCart(variantId, quantity, btn) {
  if (!variantId) return;
  const origText = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity || 1 }] })
  })
    .then(r => r.json())
    .then(() => {
      if (btn) { btn.textContent = 'Added!'; }
      refreshCart();
      setTimeout(() => { openCartDrawer(); }, 150);
      setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = origText; } }, 1500);
    })
    .catch(err => {
      console.error(err);
      if (btn) { btn.disabled = false; btn.textContent = origText; }
    });
}

// Quick-add from product cards
document.addEventListener('click', e => {
  const btn = e.target.closest('.btn-add');
  if (!btn) return;
  e.preventDefault();
  const variantId = btn.dataset.variantId;
  if (variantId) addToCart(variantId, 1, btn);
});

// ── PRODUCT PAGE: VARIANT SELECTION ──
(function() {
  const variantBtns = document.querySelectorAll('.variant-btn');
  const priceEl = document.getElementById('productPrice');
  const addBtn = document.getElementById('addToCartBtn');
  const variantInput = document.getElementById('selectedVariantId');
  if (!variantBtns.length) return;

  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      variantBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const price = btn.dataset.price;
      const comparePrice = btn.dataset.comparePrice;
      const available = btn.dataset.available === 'true';
      const variantId = btn.dataset.variantId;
      if (variantInput) variantInput.value = variantId;
      if (priceEl && price) {
        priceEl.innerHTML = money(parseInt(price)) +
          (comparePrice && parseInt(comparePrice) > parseInt(price)
            ? ` <span class="compare">${money(parseInt(comparePrice))}</span>` : '');
      }
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  });

  // Quantity control
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus = document.getElementById('qtyPlus');
  const qtyVal = document.getElementById('qtyValue');
  if (qtyMinus && qtyPlus && qtyVal) {
    qtyMinus.addEventListener('click', () => { const v = parseInt(qtyVal.value); if (v > 1) qtyVal.value = v - 1; });
    qtyPlus.addEventListener('click', () => { qtyVal.value = parseInt(qtyVal.value) + 1; });
  }

  // Product page add-to-cart
  if (addBtn) {
    addBtn.addEventListener('click', () => {
      const id = variantInput ? variantInput.value : addBtn.dataset.variantId;
      const qty = qtyVal ? parseInt(qtyVal.value) : 1;
      addToCart(id, qty, addBtn);
    });
  }
})();

// ── PRODUCT GALLERY THUMBNAILS ──
(function() {
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.getElementById('mainProductImg');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.dataset.full;
      if (src) mainImg.src = src;
    });
  });
})();

// ── CART PAGE QUANTITY ──
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-cart-qty]');
  if (!btn) return;
  const key = btn.dataset.key;
  const delta = parseInt(btn.dataset.cartQty);
  const qtyEl = btn.closest('.cart-line-actions')?.querySelector('.cart-page-qty');
  const current = qtyEl ? parseInt(qtyEl.textContent) : 1;
  updateCartLineItem(key, current + delta);
});

function updateCartLineItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
    .then(r => r.json())
    .then(() => location.reload())
    .catch(console.error);
}

// ── NEWSLETTER FORM ──
(function() {
  const form = document.getElementById('newsletterForm');
  if (!form) return;
  form.addEventListener('submit', e => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.textContent = 'Subscribed! 🌿'; btn.disabled = true; }
  });
})();

// ── INIT CART COUNT ──
fetch('/cart.js')
  .then(r => r.json())
  .then(cart => updateCartCount(cart.item_count))
  .catch(() => {});

// ── MOBILE MENU TOGGLE WITH ANIMATION ──
function toggleMobileMenu() {
  var nav = document.getElementById('mobileNav');
  var btn = document.getElementById('mobileMenuBtn');
  var overlay = document.getElementById('site-overlay');
  if (!nav) return;
  var isOpen = nav.classList.toggle('open');
  if (btn) {
    btn.classList.toggle('open', isOpen);
    btn.setAttribute('aria-expanded', isOpen);
  }
  if (nav) nav.setAttribute('aria-hidden', !isOpen);
  if (overlay) overlay.classList.toggle('active', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

// Close mobile nav on overlay click (already bound in init, but add nav-specific)
document.addEventListener('DOMContentLoaded', function() {
  // Close when any mobile nav link is clicked
  var mobileNav = document.getElementById('mobileNav');
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        if (mobileNav.classList.contains('open')) toggleMobileMenu();
      });
    });
  }
});

// ── FREE SHIPPING PROGRESS BAR IN CART ──
function renderShippingProgress(cart) {
  var threshold = parseFloat((window.PIPL_FREE_SHIP || '75').replace(/[^0-9.]/g, '')) * 100;
  var total = cart.total_price;
  var remaining = threshold - total;
  var pct = Math.min(100, Math.round(total / threshold * 100));
  var msgEl = document.querySelector('.shipping-progress-msg');
  var fillEl = document.querySelector('.shipping-progress-fill');
  if (fillEl) fillEl.style.width = pct + '%';
  if (msgEl) {
    if (remaining <= 0) {
      msgEl.innerHTML = '🌿 You qualify for <strong style="color:var(--acid)">free shipping!</strong>';
    } else {
      msgEl.textContent = '$' + (remaining / 100).toFixed(2) + ' away from free shipping';
    }
  }
}

// Patch renderCartDrawer to include shipping progress
var _origRenderCart = window.renderCartDrawer || function(){};
window.renderCartDrawer = function(cart) {
  _origRenderCart(cart);
  renderShippingProgress(cart);
};

// ── KEYBOARD TRAP FOR CART DRAWER ──
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var drawer = document.getElementById('cartDrawer');
    if (drawer && drawer.classList.contains('open')) closeCartDrawer();
  }
});
